import moment from 'moment'

// Dates were decided based on data we had
// so far and in agreement with Product

const minDate = moment('2010-01-01')
const maxDate = moment().clone().add(2, 'years').endOf('year')

export { minDate, maxDate }
